import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { installGlobalRuntimeErrorHandlers } from './lib/runtimeErrors'

installGlobalRuntimeErrorHandlers();

const Wrapper = import.meta.env.VITE_TEST_TRUE === 'true' ? React.Fragment : React.StrictMode;

ReactDOM.createRoot(document.getElementById('root')).render(
  <Wrapper>
    <App />
  </Wrapper>,
)
